/**
 * @export
 * @param {number} step
 * @returns
 */
export function toggleNewUnitStep(step) {
    return {
        type: "TOGGLE_NEW_UNIT_STEP",
        step
    };
}

export function registerValuesNewUnit(object) {
    return {
        type: "NEW_UNIT_VALUES",
        object
    }
}

/**
 * @export
 * @returns
 */
export function resetStateNewUnit() {
    return {
        type: "RESET_STATE_NEW_UNIT"
    }
}
